var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-map ml-4 mr-4" }, [
    _vm.type === "create"
      ? _c(
          "div",
          [
            _c("div", { staticClass: "row py-3 align-items-center" }, [
              _c("div", { staticClass: "col company-h1" }, [
                _c("button", {
                  staticClass: "btn btn-back",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.setCompanyStep("companies-info")
                    }
                  }
                }),
                _vm._v("\n        Create Company\n      ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ld-ext-right",
                    class: _vm.loadingButton ? "running" : "",
                    attrs: { type: "button", disabled: _vm.buttonDisabled },
                    on: {
                      click: function($event) {
                        _vm.saveAvailability()
                      }
                    }
                  },
                  [
                    _vm._v("\n          Save\n          "),
                    _c("div", { staticClass: "ld ld-ball ld-flip" })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("companies-steps-menu", { attrs: { type: "create" } })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "edit"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "row py-3 align-items-center company-header" },
            [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("h2", { staticClass: "company-h1 mr-3" }, [
                    _c("button", {
                      staticClass: "btn btn-back",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$router.push("/companies")
                        }
                      }
                    }),
                    _vm._v(
                      "\n          " + _vm._s(_vm.company.name) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.company.status
                    ? [
                        _vm.company.status.name === "Active"
                          ? _c("span", { class: "btn-status btn-active" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.company.status.name === "Inactive"
                          ? _c("span", { class: "btn-status btn-closed" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.company.status.name === "Setup Incomplete"
                          ? _c(
                              "span",
                              { class: "btn-status btn-ncover info-company" },
                              [
                                _vm._v(
                                  _vm._s(_vm.company.status.name) +
                                    "\n            "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btn btn-link p-0 tippy-popup tippy-info",
                                    on: {
                                      mouseover: function($event) {
                                        _vm.showTooltipPrefix = true
                                      },
                                      mouseout: function($event) {
                                        _vm.showTooltipPrefix = false
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-info-circle"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.showTooltipPrefix
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "popover tippy-info-popover"
                                      },
                                      [
                                        _vm._v(
                                          "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-8 d-flex align-items-center justify-content-end"
                },
                [
                  _vm.$_can("companies.review.request")
                    ? _c("companies-visibility-bar", {
                        attrs: { company: _vm.company },
                        on: {
                          saved: function($event) {
                            _vm.$emit("saved")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$_can("companies.coverage.update")
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ld-ext-right ml-5",
                          class: _vm.loadingButton ? "running" : "",
                          attrs: {
                            type: "button",
                            disabled: _vm.buttonDisabled
                          },
                          on: {
                            click: function($event) {
                              _vm.saveAvailability()
                            }
                          }
                        },
                        [
                          _vm._v("\n          Save\n          "),
                          _c("div", { staticClass: "ld ld-ball ld-flip" })
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "dropdown dropdown-menu-right pr-3" }, [
          _c(
            "div",
            {
              staticClass: "select-wrap",
              attrs: {
                id: "dropdownMenuButton",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }
            },
            [
              _c("label", [
                _vm._v("\n            Automatic assignment\n          ")
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center"
                },
                [
                  _vm.company.automatic_assignment_type
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.automatic_assignment_type.name,
                            expression: "company.automatic_assignment_type.name"
                          }
                        ],
                        staticClass: "form-control pointer",
                        attrs: { type: "text", readonly: "" },
                        domProps: {
                          value: _vm.company.automatic_assignment_type.name
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.company.automatic_assignment_type,
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-caret-down pr-3" })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown-menu dropdown-menu-right",
              attrs: { "aria-labelledby": "dropdownMenuButton" }
            },
            _vm._l(_vm.assignmentTypes, function(assignmentType) {
              return _c(
                "div",
                {
                  key: assignmentType.id,
                  staticClass: "dropdown-box border-bottom pointer",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.selectType(assignmentType)
                    }
                  }
                },
                [
                  _c("button", { staticClass: "dropdown-item" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(assignmentType.name) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(assignmentType.description))])
                ]
              )
            })
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c(
          "div",
          { staticClass: "select-wrap" },
          [
            _c("label", [_vm._v("Share with")]),
            _vm._v(" "),
            _vm.carriers
              ? _c("key-multiselect", {
                  attrs: {
                    options: _vm.carriers.filter(function(carrier) {
                      return carrier.id !== _vm.company.default_carrier_id
                    }),
                    multiple: true,
                    "clear-on-select": false,
                    "close-on-select": false,
                    "hide-selected": true,
                    "preserve-search": false,
                    label: "name",
                    "track-by": "id",
                    limit: _vm.carriers.length
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "tag",
                      fn: function(props) {
                        return [
                          _c("div", { staticClass: "multiselect__tag" }, [
                            _c("span", [_vm._v(_vm._s(props.option.name))]),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "multiselect__tag-icon",
                              on: {
                                click: function($event) {
                                  props.remove(props.option)
                                }
                              }
                            })
                          ])
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.company.shared_with_ids,
                    callback: function($$v) {
                      _vm.$set(_vm.company, "shared_with_ids", $$v)
                    },
                    expression: "company.shared_with_ids"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e535eabc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e535eabc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesAvailability.vue
// module id = null
// module chunks = 